import isStreamMonkey from '../../utils/isStreamMonkey';
import { sourceRtmpStatus, sourceType, sortSources } from '../../utils/sources';

const STATIC_RTMP_REFRESH_INTERVAL = 10000;

export default class WelcomeController {
  constructor(
    BoxCaster,
    Broadcast,
    StaticRTMP,
    ConfirmDialog,
    $uibModal,
    $state,
    $q,
    $rootScope,
    $location,
    $timeout,
    toaster,
    $scope,
    $http
  ) {
    this.rootScope = $rootScope;
    this.user = $rootScope.user;
    this.account = $rootScope.account;

    this.BoxCaster = BoxCaster;
    this.Broadcast = Broadcast;
    this.StaticRTMP = StaticRTMP;
    this.ConfirmDialog = ConfirmDialog;
    this.$uibModal = $uibModal;
    this.$state = $state;
    this.$q = $q;
    this.toaster = toaster;
    this.$location = $location;
    this.$timeout = $timeout;
    this.account = $rootScope.account;
    this.FeatureFlags = this.account.feature_flags;
    this.user = $rootScope.user;
    this.$http = $http;
    this.rtmpStatus = sourceRtmpStatus;
    this.sourceType = sourceType;
    this.numVideos = 0;
    const monthsArr = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    const dateArr = this.account.expires_on.split('-');
    this.expDate = `${monthsArr[parseInt(dateArr[1]) - 1]} ${dateArr[2]}, ${dateArr[0]}`;
    this.$http.get(`${API_ROOT}/account/migration/imports`).then((resp) => {
      this.numVideos = resp.data.length;
    });

    this.allowRtmp = this.FeatureFlags.rtmp;
    this.allowBroadcaster = !this.FeatureFlags.broadcaster_app_source_disabled;
    this.showBroadcasterSource =
      !this.FeatureFlags.broadcaster_app_source_disabled &&
      this.account.usage_flags.broadcaster_app;
    this.isStreamMonkey = isStreamMonkey(this.account.migration_service_id);

    if (this.account.status != 'onboarding') {
      this.$state.go('complete-migration.success');
    }

    this.refresh().then(() => {
      this.scheduleRefreshStaticRTMP();
    });

    $scope.$on('$destroy', () => {
      $timeout.cancel(this.timeoutHandle);
    });
  }

  refresh() {
    const { StaticRTMP, BoxCaster, Broadcast, $q } = this;

    this.boxcasters = BoxCaster.query({ l: 1000, s: 'name' });
    // Get all live now broadcasts to match up stream sources
    this.broadcasts = Broadcast.query({ q: 'timeframe:current', l: 100 });

    // Figure out which Static RTMPs are active
    this.broadcastsByBoxCaster = {};
    this.broadcastsByStaticRTMP = {};
    this.broadcastsByBroadcaster = {};

    var allPromises;
    var promises = [this.boxcasters.$promise, this.broadcasts.$promise];
    if (this.allowRtmp) {
      this.staticRTMPs = StaticRTMP.query({ l: 1000, include_diagnostics: true });
      promises.push(this.staticRTMPs.$promise);
    }

    allPromises = $q.all(promises).then(() => {
      this.broadcasts.forEach((b) => {
        if (b.stream_source == 'rtmp') {
          this.broadcastsByStaticRTMP[b.static_rtmp_id] = b;
        } else if (b.stream_source == 'boxcaster') {
          this.broadcastsByBoxCaster[b.boxcaster_id] = b;
        } else if (b.stream_source == 'app') {
          this.broadcastsByBroadcaster['__sentinel__'] = b;
        }
      });
    });

    // Wait for all data, then massage it a bit
    allPromises.then(() => {
      this.loaded = true;
      // Collapse BoxCasters and RTMP addresses into 1 big ordered list
      this.allSources = (this.boxcasters || []).concat(this.staticRTMPs || []);

      // Add Broadcaster
      if (this.showBroadcasterSource) {
        var broadcasterDetails = {};
        if (this.broadcastsByBroadcaster['__sentinel__']) {
          broadcasterDetails = this.broadcastsByBroadcaster['__sentinel__'];
        }
        this.allSources = this.allSources.concat({
          is_broadcaster: true,
          name: 'Broadcaster App',
          details: broadcasterDetails,
        });
      }

      // Sort the big list
      sortSources(this.allSources, this.broadcastsByStaticRTMP);
    });

    this.loadingPromises = [allPromises];
    return allPromises;
  }

  scheduleRefreshStaticRTMP() {
    if (this.allowRtmp && this.staticRTMPs && this.staticRTMPs.length > 0) {
      let staticRTMPs = this.StaticRTMP.query({ l: 1000, include_diagnostics: true });
      staticRTMPs.$promise
        .then(() => {
          for (var i = 0; i < this.allSources.length; i++) {
            if (sourceType(this.allSources[i]) == 'rtmp') {
              this.allSources[i].diagnostics =
                _.find(staticRTMPs, (r) => r.id == this.allSources[i].id).diagnostics ||
                this.allSources[i].diagnostics;
            }
          }
          this.staticRTMPRefreshInterval = STATIC_RTMP_REFRESH_INTERVAL;
        })
        .catch((error) => {
          console.log(error);
          // Exponential backoff up to 2 mins
          this.staticRTMPRefreshInterval = Math.min(
            (this.staticRTMPRefreshInterval || STATIC_RTMP_REFRESH_INTERVAL) * 2,
            120000
          );
        })
        .finally(() => {
          this.timeoutHandle = this.$timeout(
            () => this.scheduleRefreshStaticRTMP(),
            this.staticRTMPRefreshInterval
          );
        });
    }
  }

  toggleDetails(b, loadBoxcaster = false) {
    if (b.__showDetails) {
      b.__showDetails = false;
    } else {
      b.__showDetails = true;
      if (loadBoxcaster) {
        b.details = this.BoxCaster.get({ id: b.id });
      }
    }
  }

  openCompleteAccountModal() {
    const { rootScope } = this;
    rootScope.$emit('open-sm-modal');
    // the modal instance lives in top-navbar.js
  }
}



// WEBPACK FOOTER //
// ./app/pages/complete-migration/welcome.js